import GameCard from 'components/games/tools/GameCard';
import { useMappedState } from 'redux-react-hook';
import { useGetMyLikedGamesIdsQuery } from 'services/api/gamesApi';
import styled from 'styled-components';
import { IGame } from "types/games";

interface IScenariosSectionProps {
  scenarios: IGame[];
  onScenarioCardClick: (scenario: IGame) => void;
  characterName: string;
}


const ScenariosSection: React.FC<IScenariosSectionProps> = (props) => {
  const { scenarios, onScenarioCardClick, characterName } = props;

  const { data: myLikedGamesIds = [] } = useGetMyLikedGamesIdsQuery();

  const { hasSubscription } = useMappedState(state => {
    const currentUser = state.users.usersMap.get(state.users.currentUserId);
    const hasSubscription = currentUser?.hasSubscription;
    return {
      hasSubscription: hasSubscription,
    };
  });

  if (!scenarios.length) {
    return null;
  }

  return (
    <Root>
      <ScenariosSectionTitle>{`${characterName}’s scenarios`}</ScenariosSectionTitle>
      <div className="mx-auto box-border py-4">
        <div className="box-border grid grid-cols-1 gap-8 md:grid-cols-3 lg:grid-cols-4">
          {scenarios.map(scenario => {
            const isLikedByMe = myLikedGamesIds.includes(scenario.id);
            return (
              <GameCard
                key={scenario.id}
                item={scenario}
                onItemClick={onScenarioCardClick}
                isLikedByMe={isLikedByMe}
                likesToShow={scenario?.likesNumber}
                shouldShowLikes={!!scenario?.likesNumber}
                hasSubscription={hasSubscription}
                isVisibleTagSection
              />
            );
          })}
        </div>
      </div>
    </Root>
  );
};

export default ScenariosSection;

const Root = styled.div`
  @media (max-width: 720px) {
    padding: 0px 24px;
  }
`;

const ScenariosSectionTitle = styled.h3`
  font-family: Raleway;
  text-align: left;
  color: white;
  margin-bottom: 22px;
  font-weight: 700;
  font-size: 40px;
  line-height: 42px;

  @media (max-width: 720px) {
    font-size: 20px;
    line-height: 22px;
    margin-bottom: 8px;
  }
`;
